﻿/**
 * portal-link.repository
 * @namespace portal
 */

(function () {
	'use strict';

	/** add the repo */
	angular.module('nha.portal').service('portal-link.repository', portalLinkRepo);

	/** injection */
	portalLinkRepo.$inject = ['$q', 'repositoryFactory', 'PortalRestangular'];

	/** implementation */
	function portalLinkRepo($q, repositoryFactory, portalRestangular) {
		/** private properties */
		var pageSize = 25;
		var loadedCount = 0;
		var moreExist = true;
		var loadedLinks = [];

		/** create the repo */
		var repo = new repositoryFactory('PortalLink', portalRestangular);

		/** public methods */
		repo.search = search;
		repo.getForSettingKey = getForSettingKey;
		repo.hasPortalLink = hasPortalLink;
		repo.load = load;

		/** search the subject codes */
		function search(searchString, portalLinkGroupID) {
			/** send request */
			return portalRestangular.all(this.endpoint + '/search?searchString=' + searchString + (portalLinkGroupID ? '&excludeGroup=' + portalLinkGroupID : '')).customGET().then(function(matches) {
				/** return matches */
				return matches;
			});
		}

		/** get for the settings key */
		function getForSettingKey(settingKey) {
			/** send request */
			return portalRestangular.all(this.endpoint + '/getforsettingkey?settingKey=' + settingKey).customGET().then(function(portalLinks) {
				/** return portal links */
				return portalLinks;
			});
		}

		/** check to see if the user has the portal link */
		function hasPortalLink(settingKey) {
			/** send request */
			return portalRestangular.all(this.endpoint + '/haslink?settingKey=' + settingKey).customGET().then(function (result) {
				/** return boolean value */
				return result;
			});
		}

		/** load portal links by paging */
		function load() {
			/** prepare params and repo */
			var params = '?$top=' + pageSize + '&$skip=' + loadedCount + '&$orderby=PortalLinkName';

			/** check for moreExist */
			if (!moreExist) {
				/** return empty promise */
				var deferred = $q.defer();
				deferred.resolve(loadedLinks);
				return deferred.promise;
			}

			/** load a page of data */
			return this.getAll(null, { 'shouldCache': false, 'urlAppendString': params }).then(function(portalLinks) {
				/** add to loadedCount and check for more */
				loadedCount += portalLinks.length;
				if (portalLinks.length < pageSize) moreExist = false;

				/** add to loadedLinks and return */
				loadedLinks = loadedLinks.concat(portalLinks);
				return loadedLinks;
			});
		}

		/** return the repo */
		return repo;
	}
})();